<template>
  <div class="app bg-gray">
    <section>
      <hospital-select @selected="selectHospital"></hospital-select>
      <voucher-select :list="voucherList" @selected="selectVoucher"></voucher-select>
    </section>
    <scroll class="from-query" @refresh="refresh" style="padding-bottom: 2rem">
      <no-record :condition="surveyList" tips="抱歉，没有问卷记录"></no-record>
      <section class="thick" v-for="(survey, index) in surveyList" :key="index" @click="goToSurveyEdit(survey)">
        <div class="panel">
          <span>整体满意度</span>&nbsp;&nbsp;&nbsp;&nbsp;<span>{{ survey.degree }}</span><br />
        </div>
        <div class="content arr-row f-minor">
          <span>发布时间</span>&nbsp;&nbsp;&nbsp;&nbsp;<span>{{ survey.createTime ? new Date(survey.createTime).format('yyyy-MM-dd hh:mm:ss') : '' }}</span><br />
        </div>
        <div class="content f-minor flex-row">
          <span>平台回复</span>&nbsp;&nbsp;&nbsp;&nbsp;<span class="ellipsis-text">{{ survey.feedBack ? survey.feedBack : '未回复' }}</span><br />
        </div>
      </section>
    </scroll>
    <div class="page-footer">
      <button class="btn-ok" @click="goToSurveyAdd">填写问卷反馈</button>
    </div>
  </div>
</template>

<script>
import HospitalSelect from '../../components/HospitalSelect.vue'
import VoucherSelect from '../../components/VoucherSelect.vue'
import Scroll from '../../components/Scroll.vue'
import NoRecord from '../../components/NoRecord.vue'
import surveyListService from '../../service/surveyList.service'
import queryVoucher from '../../service/voucher.service'

export default {
  components: {
    HospitalSelect,
    VoucherSelect,
    Scroll,
    NoRecord
  },
  data() {
    return {
      voucherList: [],
      voucher: {},
      surveyList: []
    }
  },
  created() {
    // 判断是否是从推送消息过来的
    const query = this.$router.currentRoute.query;
    if(query.hospitalId) {
      //设置医院消息头和localStorage
      const hospital = {
        "hospitalId": query.hospitalId,
        "hospitalName": query.hospitalName,
      };
      localStorage.selectedHospital = JSON.stringify(hospital);
      http.headers.common['hospitalId'] = hospital.hospitalId;
      this.voucher = {
        cardNo: query.cardNo,
        cardType: query.cardType,
        holderName: query.patientName,
      }
      this.loadSurveyList();
    } else {
      this.loadVouchers();
    }
  },
  methods: {
    refresh() {
      this.loadSurveyList();
    },
    loadVouchers() {
      queryVoucher.getVoucherList().then((res) => {
        if (res.resultCode === this.constant.RESULT_SUCCESS) {
          this.voucherList = res.data;
          if (this.voucherList.length > 0) {
            this.voucher = this.voucherList[0];
            this.loadSurveyList();
          }
        }
      });
    },
    selectHospital() {
      this.loadSurveyList();
    },
    selectVoucher(voucher) {
      this.voucher = voucher;
      this.loadSurveyList();
    },
    loadSurveyList() {
      const selectedHospital = JSON.parse(localStorage.selectedHospital)
      const params = {
        hosId: selectedHospital.hospitalId,
        cardNo: this.voucher.cardNo,
        cardType: this.voucher.cardType
      };
      surveyListService.querySurveyList(params).then(res => {
        if (res.resultCode === this.constant.RESULT_SUCCESS) {
          this.surveyList = res.data;
        } else {
          this.surveyList = [];
        }
      }).catch(() => {
        this.surveyList = [];
      });
    },
    goToSurveyEdit(survey) {
      // 跳转到问卷详情页（不可编辑提交）
      const selectedHospital = JSON.parse(localStorage.selectedHospital)
      this.$router.push({
        name: 'SurveyDetail',
        params: {
          survey: survey,
          voucher: this.voucher,
          hospital: selectedHospital,
          readOnly: true
        }
      });
    },
    goToSurveyAdd() {
      // 跳到到问卷详情页（可编辑提交）
      const selectedHospital = JSON.parse(localStorage.selectedHospital)
      this.$router.push({
        name: 'SurveyDetail',
        params: {
          voucher: this.voucher,
          hospital: selectedHospital,
          readOnly: false
        }
      });
    }
  }
}
</script>

<style lang="scss" scoped>
.app {
  padding-top: 0;
}
.page-footer {
  position: absolute;
  bottom: 0;
  width: 100%;
  padding: 10px;
  background: #fff;
  box-sizing: border-box;
}
.ellipsis-text {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  display: inline-block;
  max-width: 70%;
}
</style>



// WEBPACK FOOTER //
// SurveyList.vue?08328142